import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { orderActions } from "./actions";
import { OrderState } from "./types";

const initialState: OrderState = {
  orderContent: {
    menus: [],
    totalQuantity: 0,
    totalTaxAmount: 0,
    totalPriceWithTax: 0,
  },
  orderHistory: [],
};

export function OrderReducer(state = initialState, action: Action): OrderState {
  if (isType(action, orderActions.checkOrderItems.done)) {
    return {
      ...state,
      orderContent: action.payload.result,
    };
  }

  if (isType(action, orderActions.clearOrderItems)) {
    return {
      ...state,
      orderContent: initialState.orderContent,
    };
  }

  if (isType(action, orderActions.getOrderHistory.done)) {
    return {
      ...state,
      orderHistory: action.payload.result.sort((a, b) => {
        return (
          new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()
        );
      }),
    };
  }

  if (isType(action, orderActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
